import {
  ActionButton,
  ButtonColumn,
  IconColumn,
  TableConfig,
  TextColumn,
} from 'ngx-eo-web-components';
import { Observable } from 'rxjs';
import { User } from '../../core/models/user.model';
import { TableConfigBuilder } from '../../core/interfaces/ITableConfig';

export class UsersTableConfigBuilder extends TableConfigBuilder<User> {
  private resetPasswordFunc: ((item?: User, event?: any) => void) | undefined;
  private confirmEmailFunc: ((item?: User, event?: any) => void) | undefined;

  private isResetPasswordVisibleFunc: ((item?: User) => boolean) | undefined;
  private isConfirmEmailVisibleFunc: ((item?: User) => boolean) | undefined;

  getColumns() {
    if (this.getFunction('onEditUser') == undefined) {
      return [];
    }

    if (this.getFunction('getEmailConfirmedToolTip') == undefined) {
      return [];
    }
    
    if (this.getFunction('getLockoutEnabledToolTip') == undefined) {
      return [];
    }

    const columns = [
      new TextColumn({
        name: 'Όνομα',
        propertyName: 'name',
      }),
      new TextColumn({
        name: 'Επώνυμο',
        propertyName: 'surname',
      }),
      new TextColumn({
        name: 'Όνομα Χρήστη (username)',
        propertyName: 'userName',
      }),
      new TextColumn({
        name: 'Email',
        propertyName: 'email'
      }),
        new TextColumn({
        name: 'Ρόλος',
        propertyName: 'roleLiterals',
      }),
      new IconColumn({
        name: 'Επαληθευμένο Email',
        propertyName: 'emailConfirmedIcon',
        tooltip: (item) => {
          const tooltip: any = this.getFunction('getEmailConfirmedToolTip', item) ?? '';
          return tooltip;
        }, 
      }),
      new IconColumn({
        name: 'Κλειδωμένος',
        propertyName: 'lockoutEnabledIcon',
        tooltip: (item) => {
          const tooltip: any = this.getFunction('getLockoutEnabledToolTip', item) ?? '';
          return tooltip;
        }, 
      }),
      //new TextColumn('Ρόλος', 'roles'),
      new ButtonColumn({
        classProperties: {
          icon: 'pi pi-pencil p-warning',
          styleClass: 'p-button-text',
          style: { width: '25px', height: '20px' },
          pTooltip: 'Επεξεργασία Χρήστη',
          tooltipPosition: 'bottom',
        },
        action: (item) => {
          this.getFunction('onEditUser', item);
        },
      }),
      new ButtonColumn({
        classProperties: {
          icon: 'pi pi-lock-open p-danger',
          styleClass: 'p-button-text',
          style: { width: '25px', height: '20px' },
          pTooltip: 'Αποστολή Email ανάκτησης κωδικού',
          tooltipPosition: 'left',
        },
        action: (item?: User, event?: any) => {
          if (this.resetPasswordFunc) {
            this.resetPasswordFunc(item, event);
          }
        },
        isVisibleAction: (item?: User) => {
          if (this.isResetPasswordVisibleFunc) {
            return this.isResetPasswordVisibleFunc(item);
          } else {
            return false;
          }
        },
      }),
      new ButtonColumn({
        classProperties: {
          icon: 'pi pi-envelope',
          styleClass: 'p-button-text',
          style: { width: '25px', height: '20px' },
          pTooltip: 'Αποστολή μηνύματος επιβεβαίωσης email',
          tooltipPosition: 'bottom',
        },
        action: (item?: User, event?: any) => {
          if (this.confirmEmailFunc) {
            this.confirmEmailFunc(item, event);
          }
        },
        isVisibleAction: (item?: User) => {
          if (this.isConfirmEmailVisibleFunc) {
            return this.isConfirmEmailVisibleFunc(item);
          } else {
            return false;
          }
        },
      }),
    ];

    return columns;
  }

  addResetPasswordFunction(
    resetPasswordFunc: (item?: User, event?: any) => void
  ): UsersTableConfigBuilder {
    this.resetPasswordFunc = resetPasswordFunc;
    return this;
  }

  addIsResetPasswordVisibleFunction(
    isResetPasswordVisibleFunc: (item?: User) => boolean
  ): UsersTableConfigBuilder {
    this.isResetPasswordVisibleFunc = isResetPasswordVisibleFunc;
    return this;
  }


  addConfirmEmailFunction(
    confirmEmailFunc: (item?: User, event?: any) => void
  ): UsersTableConfigBuilder {
    this.confirmEmailFunc = confirmEmailFunc;
    return this;
  }

  addIsConfirmEmailVisibleFunction(
    isConfirmEmailVisibleFunc: (item?: User) => boolean
  ): UsersTableConfigBuilder {
    this.isConfirmEmailVisibleFunc = isConfirmEmailVisibleFunc;
    return this;
  }

  getTable(data: User[]): TableConfig<User> {
    this.setTitle('')
      .setColumns(this.getColumns())
      .setTableData(data)
      .setLineNumbers(true);

    return this.getTableConfig();
  }
}
